import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { FormGroup } from '@angular/forms'
import { Observable } from 'rxjs'

import { AbstractApiDataSource } from '@app/core/services/abstract-api.datasource'
import { DriverDocumentService } from './dirver-document.service'
import { DocumentRow } from '../documents/document.model'
import { FilterValues } from '@shared/models/filter-values.model'
import { ExportFileTypes } from '@shared/models/export-file-types.enum'

export class DriverDocumentListDataSource extends AbstractApiDataSource<DocumentRow> {
  constructor(
    private driverId: number | null,
    private driverDocumentService: DriverDocumentService,
    sort: MatSort,
    paginator: MatPaginator,
    form: FormGroup,
  ) {
    super(sort, paginator, form)
  }

  getApiData(sortValue: string, filterValues: { [p: string]: string | number }): Observable<DocumentRow> {
    return this.driverDocumentService.getList(
      this.driverId,
      this.paginator.pageIndex + 1,
      this.paginator.pageSize,
      sortValue,
      filterValues,
    ) as any
  }

  getApiFileData(columns: string[], sortValue: string, filterValues: FilterValues, type: ExportFileTypes): Observable<string> {
    return this.driverDocumentService.exportFile(this.driverId, columns, sortValue, filterValues, type)
  }
}
